import { KeyOutlined } from "@mui/icons-material";
import {
  Box,
  Chip,
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { rolePermissionsBusiness } from "api/bussiness/user-role-permission/role-permission-bussiness";
import { RolePermission } from "commons/enum/permission";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IRoleProperties } from "mobx-stores/_models/user-roles/role";
import { useCallback, useEffect } from "react";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XIconButton } from "share-components/mui-wrap/button/x-icon-button";
import { useStores } from "../../../../mobx-stores/_root-store";
import { XTablePagination } from "../../../../share-components/mui-wrap/table/x-table-pagination";
export const RoleList = observer(() => {
  const {
    rolePermissionManagement: {
      roles,
      getRoles,
      setProp,
      roleSelected,
      pagination,
    },
    deleteConfirmationStore,
  } = useStores();

  useEffect(() => {
    getRoles({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditBtnClickHandler = useCallback(
    (role: IRoleProperties) => {
      setProp("openEdit", true);
      setProp("roleSelected", cloneDeep(role));
    },
    [setProp]
  );

  const onDelete = useCallback(
    async (role: IRoleProperties) => {
      if (role && role.id) {
        await rolePermissionsBusiness.deleteRole(role?.id);
        getRoles({ ...pagination.toBaseRequestModel() });
      }
    },
    [getRoles, pagination]
  );

  const onDeleteBtnClickHandler = useCallback(
    (role: IRoleProperties) => {
      setProp("roleSelected", cloneDeep(role));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(role);
      });
    },
    [deleteConfirmationStore, onDelete, setProp]
  );

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getRoles({
        ...pagination.toBaseRequestModel(),
      });
    },
    [getRoles, pagination]
  );

  const onGrantPermissionHandler = useCallback(
    (role: IRoleProperties) => {
      setProp("permissionCollection", null);
      setProp("openAssignPermissions", true);
    },
    [setProp]
  );
  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Tên</TableCell>
          <TableCell sx={{ width: "100px" }}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {roles.map((x, i) => (
          <TableRow
            onClick={() => {
              setProp("roleSelected", cloneDeep(x));
            }}
            data-id={x.id}
            key={x.id}
            hover
            sx={{
              cursor: "pointer",
            }}
            selected={x.id === roleSelected?.id}
          >
            <TableCell>
              <Stack direction={"row"} spacing={3} alignItems={"center"}>
                <Box>{x.name || ""}</Box>
                {x.isDefault && (
                  <Chip label={"Mặc định"} color="info" variant="filled" />
                )}

                {x.isStatic && (
                  <Chip label={"Hệ thống"} color="success" variant="filled" />
                )}
              </Stack>
            </TableCell>
            <TableCell sx={{ width: "100px" }}>
              {!x.isStatic && (
                <Stack direction={"row"} spacing={0.5}>
                  <Tooltip title="Phân quyền">
                    <XIconButton
                      accessPermission={[RolePermission.ManagePermissions]}
                      size="small"
                      onClick={() => onGrantPermissionHandler(x)}
                    >
                      <KeyOutlined fontSize="medium"></KeyOutlined>
                    </XIconButton>
                  </Tooltip>

                  <EditIconButton
                    accessPermission={[RolePermission.Update]}
                    onClick={() => onEditBtnClickHandler(x)}
                  ></EditIconButton>

                  <RemoveIconButton
                    accessPermission={[RolePermission.Delete]}
                    onClick={() => onDeleteBtnClickHandler(x)}
                  ></RemoveIconButton>
                </Stack>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
